(function () {
  'use strict';
  var BRACKETS = {
    tee: {
      oneSide: [
        { min: 1, off: 0 },
        { min: 4, off: 8.5 },
        { min: 6, off: 14.0 },
        { min: 11, off: 16.27 },
        { min: 26, off: 18.0 },
        { min: 51, off: 19.71 }
      ],
      twoSides: [
        { min: 1, off: 0 },
        { min: 4, off: 9.75 },
        { min: 6, off: 16.33 },
        { min: 11, off: 19.0 },
        { min: 26, off: 21.0 },
        { min: 51, off: 22.98 }
      ],
      flat100Cents: 800
    },
    hoodie: {
      oneSide: [
        { min: 1, off: 0 },
        { min: 5, off: 4.20 },
        { min: 11, off: 6.82 },
        { min: 26, off: 9.38 },
        { min: 51, off: 11.14 },
        { min: 100, off: 15.00 }
      ],
      twoSides: [
        { min: 1, off: 0 },
        { min: 5, off: 5.00 },
        { min: 11, off: 8.00 },
        { min: 26, off: 11.00 },
        { min: 51, off: 12.98 },
        { min: 100, off: 20.00 }
      ],
      flat100Cents: null
    }
  };
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function getBracketOffCents(qty, side, table) {
    var arr = side === 'Two Sides' ? table.twoSides : table.oneSide;
    var off = 0;
    for (var i = 0; i < arr.length; i++) { if (qty >= arr[i].min) off = arr[i].off; }
    return Math.round(off * 100);
  }
  function bracketPriceCents(qty, side, baseCents, table) {
    var offCents = getBracketOffCents(qty, side, table);
    var result = baseCents - offCents;
    return result > 0 ? result : baseCents;
  }
  function initBulkPricePreview(root) {
    var dataEl = root.querySelector('[data-bulk-price-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sectionId = root.getAttribute('data-section-id');
    var qtyInput = document.getElementById('Quantity-' + sectionId);
    var display = root.querySelector('[data-bulk-price-display]');
    if (!qtyInput || !display) return;
    var productKey = root.getAttribute('data-product-key') || 'tee';
    var table = BRACKETS[productKey] || BRACKETS.tee;
    var lastRenderedKey = null;
    function findVariantId() {
      var hiddenInput = document.querySelector('input.product-variant-id');
      return hiddenInput ? hiddenInput.value : null;
    }
    function render() {
      var variantId = findVariantId();
      if (!variantId) return;
      var variant = variants[variantId];
      if (!variant) return;
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty < 1) qty = 1;
      var key = variantId + ':' + qty;
      if (key === lastRenderedKey) return;
      lastRenderedKey = key;
      var unitCents;
      if (qty >= 100 && table.flat100Cents != null) {
        unitCents = table.flat100Cents;
      } else {
        unitCents = bracketPriceCents(qty, variant.side, variant.price, table);
      }
      var totalCents = unitCents * qty;
      if (qty === 1) {
        display.innerHTML = formatMoney(unitCents) + ' each';
      } else {
        display.innerHTML = '<strong>' + formatMoney(unitCents) + '</strong> each &middot; ' + qty + ' = <strong>' + formatMoney(totalCents) + '</strong> total';
      }
    }
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);
    document.addEventListener('change', render);
    document.addEventListener('click', function () { window.setTimeout(render, 50); });
    window.setInterval(render, 400);
    render();
  }
  function init() { document.querySelectorAll('[data-bulk-price-preview]').forEach(initBulkPricePreview); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
